<template>
  <div class="pricing-table is-horizontal">
    <div class="pricing-plan is-features">
      <div class="plan-header">ระดับขั้น</div>
      <div class="plan-items"></div>
      <div class="plan-footer">
        <div class="plan-price"><span class="plan-price-amount">จำนวนเงิน</span></div>
      </div>
    </div>
    <div class="pricing-plan" v-for="subscription in subscriptionsFiltered" v-bind:key="subscription.name" :class="subscription.color">
      <div class="plan-header">
        {{ subscriptionName(subscription) }}
      </div>
      <div class="plan-items">
        <div class="plan-item has-text-weight-bold is-size-5">อ่านได้ถึงตอนที่ {{ subscription.price + novel.chapterFree }} </div>
        <div class="plan-item is-size-5" v-for="special in subscription.attributes" v-bind:key="special">{{ special }}</div>
      </div>
      <div class="plan-footer">
        <div class="plan-price">
          <span class="plan-price-amount">
            <span class="plan-price-currency">{{ subscriptionPriceAttr(subscription) }} {{ subscription.currency }}</span>
              {{ subscriptionPrice(subscription) }}
            </span>
        </div>
        <button class="button is-fullwidth"
          @click="showPrivacyCondition(subscription)"
          :disabled="!subscriptionEnabled(subscription)">
          {{ subscriptionChoose(subscription) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from '@/firebase.config'
export default {
  model: {
    prop: 'subscription',
    event: 'selected'
  },
  props: {
    subscription: Object,
    list: Array,
    novel: Object
  },
  firestore () {
    return {
      subscriptionsList: db.collection('novels')
    }
  },
  data () {
    return {
      subscriptions: []
    }
  },
  computed: {
    subscriptionsFiltered () {
      if (this.$root.isImmortal) {
        return this.list.filter(subscription => subscription.id === 'immortal')
      }
      var total = this.donateTotal
      return this.list.filter(subscription => subscription.price >= total && subscription.id !== 'immortal')
    },
    donateTotal () {
      var completedPayments = this.$root.payments.filter(payment => payment.status === 'completed')
      if (completedPayments.length > 0) {
        return completedPayments.map(payment => parseInt(payment.amount)).reduce((prev, next) => prev + next)
      }
      return 0
    }
  },
  methods: {
    subscriptionEnabled (subscription) {
      if (subscription.isEnabled) {
        if (this.donateTotal >= subscription.price) {
          return false
        }
        return true
      }
      return false
    },
    subscriptionPrice (subscription) {
      if (!subscription.isEnabled) {
        return subscription.price
      }
      if (subscription.price === this.donateTotal) {
        return subscription.price
      }
      return subscription.price - this.donateTotal
    },
    subscriptionPriceAttr (subscription) {
      if (subscription.price === this.donateTotal) {
        return 'ยอดสะสมของท่าน'
      }
      return this.subscriptionPrice(subscription) < subscription.price ? 'เพิ่มอีก' : 'ยอดสะสม'
    },
    subscriptionChoose (subscription) {
      if (!subscription.isEnabled) {
        return 'ไม่เปิดสมัคร'
      }
      if (subscription.price === this.donateTotal) {
        return 'ระดับของท่าน'
      }
      return 'เลือก'
    },
    subscriptionName (subscription) {
      if (this.donateTotal === 0) {
        return subscription.name
      }
      return (subscription.price > this.donateTotal ? 'เลื่อน' : '') + subscription.name
    },
    selectSubscription (subscription) {
      subscription.name = this.subscriptionName(subscription)
      subscription.price = this.subscriptionPrice(subscription)
      this.$emit('selected', subscription)
    },
    showPrivacyCondition (subscription) {
      this.$dialog.confirm({
        title: `ข้อตกลงแปลงานวรรณกรรม`,
        message: `<p>นิยายเรื่องนี้ยังไม่มีการประกาศลิขสิทธิ์อย่างเป็นทางการ</p>
            <p>ทางผู้แปลเป็นเพียงตัวกลางในการแปล ฝึกฝนภาษาและถ่ายทอดเรื่องราวผ่านตัวหนังสือภาษาไทยเท่านั้น
            ซึ่งต่อไปขอเรียกข้อตกลงนี้ว่า "ผู้แปล" อีกฝ่ายหนึ่ง ผู้อ่าน มีข้อความดังต่อไปนี้</p>
            <p><b>1. วัตถุประสงค์ในข้อตกลง</b></p>
              <p><li>ทางเว็บไซต์ read-thai.com แปลงานวรรณกรรมต้นฉบับซึ่งต่อไปนี้จะเรียกว่า "งานแปล" เพื่อให้อ่านฟรีตามตอนที่กำหนดไว้ ผู้แปลตกลงจะแปลวรรณกรรมต้นฉบับเป็นภาษาไทยตามเงื่อนไขที่ได้ระบุไว้ตามข้อตกลงนี้</li></p>
            <p><b><ul>2. เงื่อนไขการแปล</ul></b></p>
              <p><li>ผู้แปลตกลงจะแปลวรรณกรรมต้นฉบับเป็นภาษาไทยโดยเคารพต้นฉบับเดิมอย่างถูกต้องครบถ้วน ทั้งในด้านเนื้อหา วิธีเขียนและรูปแบบการเขียนโดยจะไม่ทำการแก้ไข ดัดแปลง เพิ่มเติม หรือตัดทอนงานวรรณกรรมต้นฉบับแต่อย่างใดเว้นแต่จะได้รับอนุญาตจากเจ้าของลิขสิทธิ์</li></p>
              <p><li>กรณีที่มีข้อขัดแย้งระหว่างสำนักพิมพ์หรือเจ้าของลิขสิทธิ์เกี่ยวกับงานแปล และข้อขัดแย้งดังกล่าวไม่สามารถตกลงกันได้ ให้คู่กรณีนำสัญญาข้อขัดแย้งเข้าสู่การพิจารณาของผู้ทรงคุณวุฒิที่สำนักพิมพ์และเจ้าของลิขสิทธิ์เห็นชอบร่วมกันแต่งตั้งจำนวน 1 คน และให้คำวินิจฉัยของผู้ทรงคุณวุฒิมีผลผูกพันคู่สัญญาทั้งสองฝ่าย ทั้งนี้ค่าใช้จ่ายที่เกิดขึ้นจากกระบวนการพิจารณาให้สำนักพิมพ์หรือเจ้าของลิขสิทธิ์เป็นผู้รับผิดชอบ</li></p>
              <p><li>ผู้แปลรับรองว่าจะแปลวรรณกรรมต้นฉบับตามข้อตกลงนี้ด้วยตนเอง และจะเป็นผู้รับผิดชอบงานแปลที่ได้สร้างสรรค์ขึ้น</li></p>
            <p><b><ul>3. ระยะเวลาในการแปล</ul></b></p>
              <p><li>ผู้แปลจะแปลวรรณกรรมต้นฉบับให้อ่านตามระบบสนับสนุนวันละ 2 ตอนตามที่ได้รับรองไว้ หากไม่สามารถลงได้ตามปกติจะลงชดเชยวันอื่นให้เท่ากับวันที่ไม่สามารถลงให้ได้ตามที่เห็นสมควร</li></p>
              <p><li>ผู้แปลจะส่งมอบงานแปลให้กับผู้อ่านในรูปแบบของเนื้อหาผ่านทางเว็บไซต์ read-thai.com</li></p>
            <p><b><ul>4. การระบุชื่อผู้สร้างสรรค์และข้อมูลอื่นๆ</ul></b></p>
              <p><li>ในการลงตอนแปลแต่ละครั้ง จะระบุวัน เดือน ปีที่ลงแปลครั้งแรกให้ปรากฏในส่วนที่สังเกตเห็นได้ชัดเจน</li></p>
            <p><b><ul>5. การโอนสิทธิและ/หรือหน้าที่ตามข้อตกลงนี้</ul></b></p>
              <p><li>สำนักพิมพ์และ/หรือผู้ถือครองลิขสิทธิ์และผู้แปลไม่สามารถโอนสิทธิและ/หรือหน้าที่รับผิดชอบของตนตามข้อตกลงนี้ให้แก่บุคคลภายนอกได้ เว้นแต่จะได้รับความยินยอมเป็นลายลักษณ์อักษรจากอีกฝ่ายหนึ่งก่อน</li></p>
            <br><br>
            <h2>หากรับทราบเรื่องลิขสิทธิ์อย่างถูกต้อง ผู้ดูแลจะทำการลบเรื่องที่ได้รับลิขสิทธิ์ภายในระยะเวลา 3 วันหรือตามข้อตกลงกับผู้ถือครองลิขสิทธิ์</h2>
            <h2><span style="color: rgb(230, 0, 0);">ยอดการสนับสนุนของท่านหากนิยายได้รับลิขลิทธิ์ไปแล้วจะไม่มีการคืนเงินใดๆทั้งสิ้นเพราะถือว่าเป็นส่วนช่วยเหลือให้ผู้แปลดำเนินการแปลต่อไปได้</span></h2>
            `,
        cancelText: 'ไม่ยอมรับ',
        confirmText: 'ยอมรับ',
        type: 'is-success',
        onConfirm: () => this.selectSubscription(subscription)
      })
    }
  }
}
</script>

<style lang="scss">

</style>
